import React from 'react';
import { Autocomplete, Chip, TextField } from '@mui/material';
import PersonOutlineRounded from '@mui/icons-material/PersonOutlineRounded';

interface AgentFilterSelectProps {
  options: string[];
  value: string[];
  onChange: (agents: string[]) => void;
  disabled?: boolean;
}

export default function AgentFilterSelect({
  options,
  value,
  onChange,
  disabled,
}: AgentFilterSelectProps) {
  return (
    <Autocomplete
      multiple
      size="small"
      limitTags={1}
      value={value}
      onChange={(_e, next) => onChange(next)}
      options={options}
      disabled={disabled}
      disableCloseOnSelect
      autoHighlight
      sx={{ width: 240 }}
      renderTags={(selected, getTagProps) =>
        selected.map((agent, index) => (
          <Chip
            {...getTagProps({ index })}
            key={agent}
            size="small"
            label={agent}
            sx={{ height: 20, '& .MuiChip-label': { px: 0.75, fontSize: 11 } }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={value.length ? '' : 'All agents'}
          label="Agent"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <PersonOutlineRounded sx={{ fontSize: 16, color: 'text.disabled', ml: 0.5, mr: -0.25 }} />
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
